import type { RefObject } from 'react';
import { TrashIcon } from '@/components/icons';
import { Button } from './Button';
import { Modal } from './Modal';
import './ConfirmationModal.css';

/** Confirmation partagée : la modale reste ouverte pendant l'envoi et en cas d'erreur. */
export const ConfirmationModal = ({
  title = 'Confirmer la suppression',
  description,
  confirmLabel = 'Supprimer',
  pending = false,
  error,
  onConfirm,
  onCancel,
  returnFocusRef,
}: {
  title?: string;
  description: string;
  confirmLabel?: string;
  pending?: boolean;
  error?: string | undefined;
  onConfirm: () => void;
  onCancel: () => void;
  returnFocusRef?: RefObject<HTMLElement | null>;
}) => (
  <Modal
    variant="confirmation"
    role="alertdialog"
    title={title}
    description={description}
    icon={<TrashIcon />}
    onClose={onCancel}
    closeDisabled={pending}
    closeLabel="Fermer la confirmation"
    {...(returnFocusRef ? { returnFocusRef } : {})}
    footer={
      <div className="confirmation-modal__actions">
        <Button variant="secondary" disabled={pending} onClick={onCancel}>
          Annuler
        </Button>
        <Button
          className="confirmation-modal__confirm"
          loading={pending}
          loadingLabel="Suppression…"
          onClick={() => {
            if (!pending) onConfirm();
          }}
        >
          {confirmLabel}
        </Button>
      </div>
    }
  >
    {error ? (
      <p className="confirmation-modal__error" role="alert">
        {error}
      </p>
    ) : null}
  </Modal>
);
